module.exports = __webpack_public_path__ + "media/slider/Banner-6-US-923569d9.jpg";